const comBg = (() => {
  const jsComSecBg = (document.getElementById("jsComSecBg") != null);
  if (jsComSecBg) {



    const comSecBg = document.getElementById('jsComSecBg');
    const bgWrap = comSecBg.querySelector('.js-bg-wrap');
    const canvas = bgWrap.querySelector('.js-canvas');
    const triggers = document.querySelectorAll('.js-com-sec-bg-trigger');


    // pageLocation
    const pageLocation = (document.getElementById("pageLocation") != null);
    if (pageLocation) {

      let granimInstance = new Granim({
        element: canvas,
        direction: "top-bottom",
        opacity: [1, 1],
        isPausedWhenNotInView: true,
        states: {
          "default-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          },
          "blu-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#ffffff", "#95b2c6"],
              ["#7991a9", "#82777b"]
            ]
          },
          "red-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          }
        }
      });


      // let tl = gsap.timeline({
      //   scrollTrigger: {
      //     invalidateOnRefresh: true,
      //     trigger: triggers[0],
      //     start: "0% 10%",
      //     onEnter: () => granimInstance.changeState('blu-state'),
      //     // onEnterBack: () => console.log("onEnterBack"),
      //     // onLeave: () => console.log("onLeave"),
      //     onLeaveBack: () => granimInstance.changeState('red-state'),
      //     // markers: true,
      //   },
      // })
      // let tl1 = gsap.timeline({
      //   scrollTrigger: {
      //     invalidateOnRefresh: true,
      //     trigger: triggers[1],
      //     start: "0% 10%",
      //     onEnter: () => granimInstance.changeState('red-state'),
      //     // onEnterBack: () => console.log("onEnterBack"),
      //     // onLeave: () => console.log("onLeave"),
      //     onLeaveBack: () => granimInstance.changeState('blu-state'),
      //     // markers: true,
      //   },
      // })


      // let target = document.querySelector('body');
      // let observer = new ResizeObserver((entries) => {
      //   entries.forEach((entry) => {
      //     tl.scrollTrigger.refresh()
      //     tl1.scrollTrigger.refresh()
      //   });
      // });
      // observer.observe(target);

    }
    // pageLocation end


    // pageBricksBeaute
    const pageBricksBeaute = (document.getElementById("pageBricksBeaute") != null);
    if (pageBricksBeaute) {

      let granimInstance = new Granim({
        element: canvas,
        direction: "top-bottom",
        opacity: [1, 1],
        isPausedWhenNotInView: true,
        states: {
          "default-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          },
          "blu-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#ffffff", "#95b2c6"],
              ["#7991a9", "#82777b"]
            ]
          },
          "red-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          }
        }
      });


      let tl = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: triggers[0],
          start: "0% 10%",
          onEnter: () => granimInstance.changeState('blu-state'),
          // onEnterBack: () => console.log("onEnterBack"),
          // onLeave: () => console.log("onLeave"),
          onLeaveBack: () => granimInstance.changeState('red-state'),
          // markers: true,
        },
      })
      let tl1 = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: triggers[1],
          start: "0% 10%",
          onEnter: () => granimInstance.changeState('red-state'),
          // onEnterBack: () => console.log("onEnterBack"),
          // onLeave: () => console.log("onLeave"),
          onLeaveBack: () => granimInstance.changeState('blu-state'),
          // markers: true,
        },
      })


      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          tl.scrollTrigger.refresh()
          tl1.scrollTrigger.refresh()
        });
      });
      observer.observe(target);

    }
    // pageBricksBeaute end



    // pageDesign
    const pageDesign = (document.getElementById("pageDesign") != null);
    if (pageDesign) {

      let granimInstance = new Granim({
        element: canvas,
        direction: "top-bottom",
        opacity: [1, 1],
        isPausedWhenNotInView: true,
        states: {
          "default-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          },
          "blu-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#ffffff", "#95b2c6"],
              ["#7991a9", "#82777b"]
            ]
          },
          "red-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          }
        }
      });


      // let tl = gsap.timeline({
      //   scrollTrigger: {
      //     invalidateOnRefresh: true,
      //     trigger: triggers[0],
      //     start: "0% 10%",
      //     onEnter: () => granimInstance.changeState('blu-state'),
      //     // onEnterBack: () => console.log("onEnterBack"),
      //     // onLeave: () => console.log("onLeave"),
      //     onLeaveBack: () => granimInstance.changeState('red-state'),
      //     // markers: true,
      //   },
      // })
      // let tl1 = gsap.timeline({
      //   scrollTrigger: {
      //     invalidateOnRefresh: true,
      //     trigger: triggers[1],
      //     start: "0% 10%",
      //     onEnter: () => granimInstance.changeState('red-state'),
      //     // onEnterBack: () => console.log("onEnterBack"),
      //     // onLeave: () => console.log("onLeave"),
      //     onLeaveBack: () => granimInstance.changeState('blu-state'),
      //     // markers: true,
      //   },
      // })


      // let target = document.querySelector('body');
      // let observer = new ResizeObserver((entries) => {
      //   entries.forEach((entry) => {
      //     tl.scrollTrigger.refresh()
      //     tl1.scrollTrigger.refresh()
      //   });
      // });
      // observer.observe(target);

    }
    // pageDesign end



    // pageEquipment
    const pageEquipment = (document.getElementById("pageEquipment") != null);
    if (pageEquipment) {

      let granimInstance = new Granim({
        element: canvas,
        direction: "top-bottom",
        opacity: [1, 1],
        isPausedWhenNotInView: true,
        states: {
          "default-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          },
          "blu-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#ffffff", "#95b2c6"],
              ["#7991a9", "#82777b"]
            ]
          },
          "red-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          }
        }
      });


      let tl = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: triggers[0],
          start: "0% 10%",
          onEnter: () => granimInstance.changeState('blu-state'),
          // onEnterBack: () => console.log("onEnterBack"),
          // onLeave: () => console.log("onLeave"),
          onLeaveBack: () => granimInstance.changeState('red-state'),
          // markers: true,
        },
      })


      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          tl.scrollTrigger.refresh()
        });
      });
      observer.observe(target);

    }
    // pageEquipment end



    // pageQuality
    const pageQuality = (document.getElementById("pageQuality") != null);
    if (pageQuality) {

      let granimInstance = new Granim({
        element: canvas,
        direction: "top-bottom",
        opacity: [1, 1],
        isPausedWhenNotInView: true,
        states: {
          "default-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          },
          "blu-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#ffffff", "#95b2c6"],
              ["#7991a9", "#82777b"]
            ]
          },
          "red-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          }
        }
      });


      let tl = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: triggers[0],
          start: "0% 10%",
          onEnter: () => granimInstance.changeState('blu-state'),
          // onEnterBack: () => console.log("onEnterBack"),
          // onLeave: () => console.log("onLeave"),
          onLeaveBack: () => granimInstance.changeState('red-state'),
          // markers: true,
        },
      })


      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          tl.scrollTrigger.refresh()
        });
      });
      observer.observe(target);

    }
    // pageQuality end



    // pageHospitality
    const pageHospitality = (document.getElementById("pageHospitality") != null);
    if (pageHospitality) {

      let granimInstance = new Granim({
        element: canvas,
        direction: "top-bottom",
        opacity: [1, 1],
        isPausedWhenNotInView: true,
        states: {
          "default-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          },
          "blu-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#ffffff", "#95b2c6"],
              ["#7991a9", "#82777b"]
            ]
          },
          "red-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          }
        }
      });


      let tl = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: triggers[0],
          start: "0% 10%",
          onEnter: () => granimInstance.changeState('blu-state'),
          // onEnterBack: () => console.log("onEnterBack"),
          // onLeave: () => console.log("onLeave"),
          onLeaveBack: () => granimInstance.changeState('red-state'),
          // markers: true,
        },
      })


      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          tl.scrollTrigger.refresh()
        });
      });
      observer.observe(target);

    }
    // pageHospitality end



    // pagePlan
    const pagePlan = (document.getElementById("pagePlan") != null);
    if (pagePlan) {

      let granimInstance = new Granim({
        element: canvas,
        direction: "top-bottom",
        opacity: [1, 1],
        isPausedWhenNotInView: true,
        states: {
          "default-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          },
          "blu-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#ffffff", "#95b2c6"],
              ["#7991a9", "#82777b"]
            ]
          },
          "red-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          }
        }
      });


      // let tl = gsap.timeline({
      //   scrollTrigger: {
      //     invalidateOnRefresh: true,
      //     trigger: triggers[0],
      //     start: "0% 10%",
      //     onEnter: () => granimInstance.changeState('blu-state'),
      //     // onEnterBack: () => console.log("onEnterBack"),
      //     // onLeave: () => console.log("onLeave"),
      //     onLeaveBack: () => granimInstance.changeState('red-state'),
      //     // markers: true,
      //   },
      // })
      // let tl1 = gsap.timeline({
      //   scrollTrigger: {
      //     invalidateOnRefresh: true,
      //     trigger: triggers[1],
      //     start: "0% 10%",
      //     onEnter: () => granimInstance.changeState('red-state'),
      //     // onEnterBack: () => console.log("onEnterBack"),
      //     // onLeave: () => console.log("onLeave"),
      //     onLeaveBack: () => granimInstance.changeState('blu-state'),
      //     // markers: true,
      //   },
      // })


      // let target = document.querySelector('body');
      // let observer = new ResizeObserver((entries) => {
      //   entries.forEach((entry) => {
      //     tl.scrollTrigger.refresh()
      //     tl1.scrollTrigger.refresh()
      //   });
      // });
      // observer.observe(target);

    }
    // pagePlan end


    // pageType
    const pageType = (document.getElementById("pageType") != null);
    if (pageType) {

      let granimInstance = new Granim({
        element: canvas,
        direction: "top-bottom",
        opacity: [1, 1],
        isPausedWhenNotInView: true,
        states: {
          "default-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#ffffff", "#95b2c6"],
              ["#7991a9", "#82777b"]
            ]
          },
          "blu-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#ffffff", "#95b2c6"],
              ["#7991a9", "#82777b"]
            ]
          },
          "red-state": {
            transitionSpeed: 6000,
            loop: true,
            gradients: [
              ["#efb997", "#dbc7ae"],
              ["#8ba8b0", "#c6cfca"],
              ["#eee8da", "#d2d5cc"]
            ]
          }
        }
      });


      // let tl = gsap.timeline({
      //   scrollTrigger: {
      //     invalidateOnRefresh: true,
      //     trigger: triggers[0],
      //     start: "0% 10%",
      //     onEnter: () => granimInstance.changeState('blu-state'),
      //     // onEnterBack: () => console.log("onEnterBack"),
      //     // onLeave: () => console.log("onLeave"),
      //     onLeaveBack: () => granimInstance.changeState('red-state'),
      //     // markers: true,
      //   },
      // })
      // let tl1 = gsap.timeline({
      //   scrollTrigger: {
      //     invalidateOnRefresh: true,
      //     trigger: triggers[1],
      //     start: "0% 10%",
      //     onEnter: () => granimInstance.changeState('red-state'),
      //     // onEnterBack: () => console.log("onEnterBack"),
      //     // onLeave: () => console.log("onLeave"),
      //     onLeaveBack: () => granimInstance.changeState('blu-state'),
      //     // markers: true,
      //   },
      // })


      // let target = document.querySelector('body');
      // let observer = new ResizeObserver((entries) => {
      //   entries.forEach((entry) => {
      //     tl.scrollTrigger.refresh()
      //     tl1.scrollTrigger.refresh()
      //   });
      // });
      // observer.observe(target);

    }
    // pageType end



  }
})();
export default comBg;